module.exports = __webpack_public_path__ + "static/cima-logo-3a1af14f9bc27345fc59c4552d58af99.png";